import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ spacing }) => ({
  iconButton: {
    boxShadow: "none",
    padding: spacing(1),
  },
  badgeTopRightRectangle: {
    transform: "scale(1) translate(-50%, 50%)",
  },
}));
